module.exports = __webpack_public_path__ + "img/cpzz4@2x.92e13a82.png";